import { RequestMode } from "@/types/common";
import { E2EService, RequestService } from "@/services";
import { CommonUtils } from "@/utils";

const useImportRequest = (mode: RequestMode) => {
  const importRequest = async (file: File) => {
    const buffer = await file.arrayBuffer();
    const decryptFile = await E2EService.decryptFile(buffer);
    const fileDecrypt = CommonUtils.arrayBufferToFile(decryptFile, file.type, file.name);
    const formData = new FormData();
    formData.append("file", fileDecrypt);
    formData.append("mode", mode);
    return RequestService.importRequest(formData);
  };

  return {
    importRequest,
  };
};

export default useImportRequest;
